import { render } from "./DropDownButton.vue?vue&type=template&id=597479ba"
import script from "./DropDownButton.vue?vue&type=script&lang=ts"
export * from "./DropDownButton.vue?vue&type=script&lang=ts"

import "./DropDownButton.vue?vue&type=style&index=0&id=597479ba&lang=scss"
script.render = render

export default script